import React from "react";

import styled from "@mui/material/styles/styled";

import type { FeedItem } from "@app/analytics/Home/types";

import { Column, Row } from "@rui/Stack";

import ROUTES from "@rss/common/routes";

import HomeFeedItemHeader from "../HomeFeedItemHeader";

const HeaderContainer = styled(Row)(({ theme }) => ({
  padding: theme.spacing(1.5),
  borderBottom: "1px solid",
  borderColor: theme.palette.shades.neutral[100],
  width: "100%",
}));

interface DetailsPanelHeaderProps {
  alert?: React.ReactNode;
  item: FeedItem;
  onClose: () => void;
}

const DetailsPanelHeader = ({
  alert,
  item,
  onClose,
}: DetailsPanelHeaderProps) => {
  return (
    <HeaderContainer>
      <Column spacing={1} width="100%">
        <HomeFeedItemHeader
          align="left"
          link={{
            label: item.session.title,
            href: ROUTES.meetingReportById(item.session.id),
          }}
          onClose={onClose}
          timestamp={item.timestamp}
          title={item.title}
          type={item.type}
        />
        {alert}
      </Column>
    </HeaderContainer>
  );
};

export default DetailsPanelHeader;
